import { Modal } from 'react-bootstrap';

const FundDetailsModal = ({ show, onHide, content }) => {
    return (
        <Modal show={show} onHide={onHide} size='xl'  centered>
            <Modal.Body>
                <span
                    onClick={onHide}
                    style={{
                        position: "absolute",
                        top: "14px",
                        right: "18px",
                        zIndex: 9999,
                        cursor: "pointer",
                        color: "#ffffff",
                        fontSize: "28px",
                        fontWeight: "600",
                        lineHeight: 1,
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        background: "rgba(0,0,0,0.18)",
                        backdropFilter: "blur(4px)"
                    }}
                >
                    ×
                </span>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </Modal.Body>
        </Modal>
    );
};

export default FundDetailsModal;
